import type { MouseEvent as ReactMouseEvent } from 'react'

type NavigationClick = Pick<
  ReactMouseEvent<HTMLElement>,
  'button' | 'ctrlKey' | 'metaKey'
> & Partial<Pick<ReactMouseEvent<HTMLElement>, 'altKey' | 'shiftKey'>>

export function isModifiedNavigationClick(event: NavigationClick): boolean {
  return Boolean(event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey)
}

/**
 * Opens a placeholder tab synchronously for async navigation buttons.
 *
 * Plain page navigation should always use an anchor or Next Link. This helper
 * is only for destinations that do not exist until a click-time request
 * resolves, such as Stripe Checkout, the billing portal, and OAuth.
 */
export function openModifiedClickTarget(event: NavigationClick): Window | null {
  if (event.button !== 0 || (!event.metaKey && !event.ctrlKey)) return null

  const target = window.open('about:blank', '_blank')
  if (target) {
    target.opener = null
    target.document.title = 'Opening…'
  }
  return target
}

export function navigateToResolvedUrl(url: string, target: Window | null): void {
  if (target && !target.closed) {
    target.location.replace(url)
    return
  }
  window.location.assign(url)
}

export function closeNavigationTarget(target: Window | null): void {
  if (target && !target.closed) target.close()
}
